import axios from "axios";
import { delveBaseURL } from "../config/Api.config";

import { replaceUrlVariables } from "../utils/updateUrlParams";
import { NetworkCallPayload } from "./networkHandler.types";
import { getCountryUrlByKey } from "utils/urlUtils";
import { filterConflictingHeaders, getStoredHeaders } from "utils/storageUtils";
import { COUNTRY_URL_KEYS } from "constants/CommonConstants";
import isEmpty from "lodash/isEmpty";

const networkHandlerDelve = async (params: NetworkCallPayload) => {
  const { url, urlParams, headers, ...restApiOptions } = params;
  let updateUrl = url;
  if (urlParams) {
    updateUrl = replaceUrlVariables(url, urlParams);
  }

  axios.defaults.baseURL = getCountryUrlByKey(COUNTRY_URL_KEYS.DELVE) || delveBaseURL;
  axios.defaults.headers.common = {
    Authorization: sessionStorage.getItem("token"),
  };
  axios.defaults.headers.common["system-id"] = "CWINGS";
  const requestHeaders = headers || {};
  const storedHeaders = getStoredHeaders(COUNTRY_URL_KEYS.DELVE);
  if (storedHeaders && !isEmpty(storedHeaders)) {
    // Filter out headers that already exist in requestHeaders or defaults
    const allExistingHeaders = {
      ...axios.defaults.headers.common,
      ...requestHeaders
    };
    const filteredHeaders = filterConflictingHeaders(storedHeaders, allExistingHeaders);
    Object.assign(requestHeaders, filteredHeaders);
  }
  return await axios.request({
    url: updateUrl,
    headers: requestHeaders,
    ...restApiOptions,
  });
};

export default networkHandlerDelve;
